import { Component, NgZone, OnInit } from '@angular/core';
import { AuthService } from '../../../auth.service';
import { PaymentService } from '../../../../dashboard/profile/payment.service';

@Component({
  selector: 'app-free',
  templateUrl: './free.component.html',
  styleUrls: ['./free.component.scss'],
})
export class FreeComponent implements OnInit {
  signupEmail: string | undefined;

  constructor(
    private paymentService: PaymentService,
    private readonly ngZone: NgZone,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.signupEmail = this.authService.getSignupEmail();
  }

  async acceptAndContinue(): Promise<void> {
    if (this.signupEmail) {
      await this.paymentService.subscribeForFree(this.signupEmail);
      this.ngZone.run(() =>
        this.authService.navigateToPage('/auth/login', { signupSuccess: true, email: this.signupEmail }),
      );
    }
  }
}
